import React, { useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as ZoomIn } from '../Map/MapControls/MapControlsZoom/MobileMapControlsZoomMoreIcon.svg';

const SiteSeeZoomInGuide = () => {
  const { siteSeeName, actionWord } = useContext(SiteSeeContext);

  return (
    <>
      {` ${actionWord} the`}

      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        <ZoomIn />
      </span>

      icon in the
      {' '}
      {siteSeeName}
      {' '}
      control bar below to zoom in and reveal community residences and amenities.
    </>
  );
};

export default SiteSeeZoomInGuide;
